import React, { useState, useEffect } from 'react'

import { Form, Input, Select, InputNumber, Button, Checkbox } from 'antd'
import PropTypes from 'prop-types'
import { DeleteOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import { EnFormItem } from '../shared/LocalizedFields'

const StyledDivDelete = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const PlaylistForm = ({
  form,
  id,
  titleKZ,
  titleRU,
  titleEN,
  songs,
  index,
  status,
  descriptionKZ,
  descriptionRU,
  descriptionEN,
  setCoverImageFile,
  coverImageFileRef,
  allSongs,
  removeFilesHandler,
  isFeatured,
  featuredSongs,
  featuredOrder
}) => {
  // console.log('songs', songs)
  const FormItem = Form.Item
  const [showFeaturedOptions, setShowFeaturedOptions] = useState(isFeatured || false)
  const [selectedPlaylistSongs, setSelectedPlaylistSongs] = useState(
    songs?.map(item => (item ? item?.id : item)) || []
  )

  // Обновляем selectedPlaylistSongs при изменении props songs (для редактирования)
  useEffect(() => {
    const songIds = songs?.map(item => (item ? item?.id : item)) || []
    setSelectedPlaylistSongs(songIds)
  }, [songs])

  return (
    <Form form={form} layout="vertical" hideRequiredMark>
      <div style={{ marginBottom: '3%' }}>
        <>Обложка</>
        <StyledDivDelete>
          <input
            type="file"
            accept="image/*"
            ref={coverImageFileRef}
            onChange={event => setCoverImageFile(event.target.files[0])}
          />
          {id && (
            <Button
              danger
              onClick={() => {
                removeFilesHandler(id)
              }}
            >
              <DeleteOutlined />
            </Button>
          )}
        </StyledDivDelete>
      </div>

      <FormItem
        key="status"
        label="Статус документа"
        name="status"
        rules={[
          {
            required: true,
            message: `Пожалуйста, выберите статус`
          }
        ]}
        initialValue={status}
      >
        <Select placeholder="Выберите" mode="single">
          <Select.Option key="active" value="active">
            Автивный
          </Select.Option>
          <Select.Option key="inactive" value="inactive">
            Скрытый
          </Select.Option>
        </Select>
      </FormItem>
      <FormItem
        key="index"
        label="Очередность документа"
        name="index"
        rules={[
          {
            required: true,
            message: `Пожалуйста, введите Очередность документа`
          }
        ]}
        initialValue={index}
      >
        <InputNumber min={1} placeholder="Очередность документа" />
      </FormItem>
      {/* <FormItem
        key="title"
        label="Название"
        name="title"
        rules={[
          {
            required: true,
            message: `Пожалуйста, введите название Плейлиста`
          }
        ]}
        initialValue={title}
      >
        <Input placeholder="Название" />
      </FormItem> */}
      <FormItem
        key="titleKZ"
        label="Название(каз)"
        name="titleKZ"
        rules={[
          {
            required: true,
            message: `Пожалуйста, введите название Плейлиста на казахском`
          }
        ]}
        initialValue={titleKZ}
      >
        <Input placeholder="Аты" />
      </FormItem>
      <FormItem
        key="titleRU"
        label="Название(рус)"
        name="titleRU"
        rules={[
          {
            required: true,
            message: `Пожалуйста, введите название Плейлиста на русском`
          }
        ]}
        initialValue={titleRU}
      >
        <Input placeholder="Название" />
      </FormItem>
      <EnFormItem
        name="titleEN"
        label="Название(англ)"
        initialValue={titleEN}
      />
      <FormItem
        key="songs"
        label="Аудио дорожки"
        name="songs"
        rules={[
          {
            required: true,
            message: `Пожалуйста, выберите аудио дорожки`
          }
        ]}
        initialValue={songs.map(item => (item ? item?.id : item))}
      >
        <Select
          placeholder="Выберите аудио дорожки"
          mode="multiple"
          allowClear
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          onChange={(values) => {
            setSelectedPlaylistSongs(values)
            // Очищаем featuredSongs если они больше не входят в выбранные песни
            const currentFeaturedSongs = form.getFieldValue('featuredSongs') || []
            const validFeaturedSongs = currentFeaturedSongs.filter(songId => values.includes(songId))
            form.setFieldsValue({ featuredSongs: validFeaturedSongs })
          }}
        >
          {allSongs.songs.map(song => (
            <Select.Option key={song.id} value={song.id}>
              {`${song.title} - ${song?.voiceActors
                ?.map(item => item?.name)
                .join(', ')}`}
            </Select.Option>
          ))}
        </Select>
      </FormItem>
      <FormItem
        key="descriptionKZ"
        label="Описание на казахском"
        name="descriptionKZ"
        rules={[
          {
            required: false,
            message: `Пожалуйста, напишите короткое описание`
          }
        ]}
        initialValue={descriptionKZ}
      >
        <Input.TextArea placeholder="Описание..." />
      </FormItem>
      <FormItem
        key="descriptionRU"
        label="Описание на русском"
        name="descriptionRU"
        rules={[
          {
            required: false,
            message: `Пожалуйста, напишите короткое описание`
          }
        ]}
        initialValue={descriptionRU}
      >
        <Input.TextArea placeholder="Описание..." />
      </FormItem>
      <EnFormItem
        name="descriptionEN"
        label="Описание на английском"
        initialValue={descriptionEN}
        multiline
      />

      <FormItem
        key="isFeatured"
        label="Выделенный плейлист"
        name="isFeatured"
        valuePropName="checked"
        initialValue={isFeatured}
      >
        <Checkbox onChange={e => setShowFeaturedOptions(e.target.checked)}>
          Отображать как выделенный плейлист
        </Checkbox>
      </FormItem>

      {showFeaturedOptions && (
        <>
          <FormItem
            key="featuredOrder"
            label="Порядок в выделенных"
            name="featuredOrder"
            rules={[
              {
                required: true,
                message: `Пожалуйста, укажите порядок в выделенных плейлистах`
              }
            ]}
            initialValue={featuredOrder}
          >
            <InputNumber min={1} placeholder="Порядок в выделенных" />
          </FormItem>

          <FormItem
            key="featuredSongs"
            label="Приоритетные песни (максимум 3)"
            name="featuredSongs"
            initialValue={featuredSongs?.map(item => (item ? item?.id : item)) || []}
          >
            <Select
              placeholder="Выберите до 3 приоритетных песен"
              mode="multiple"
              allowClear
              showSearch
              maxTagCount={3}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              onSelect={(value, option) => {
                const currentValues = form.getFieldValue('featuredSongs') || []
                if (currentValues.length >= 3) {
                  form.setFieldsValue({
                    featuredSongs: currentValues.slice(0, 3)
                  })
                }
              }}
            >
              {allSongs.songs
                .filter(song => selectedPlaylistSongs.includes(song.id))
                .map(song => (
                  <Select.Option key={song.id} value={song.id}>
                    {`${song.title} - ${song?.voiceActors
                      ?.map(item => item?.name)
                      .join(', ')}`}
                  </Select.Option>
                ))}
            </Select>
          </FormItem>
        </>
      )}
    </Form>
  )
}

PlaylistForm.propTypes = {
  form: PropTypes.objectOf(PropTypes.any).isRequired,
  titleKZ: PropTypes.string,
  titleRU: PropTypes.string,
  titleEN: PropTypes.string
}

PlaylistForm.defaultProps = {
  titleKZ: '',
  titleRU: '',
  titleEN: '',
  songs: [],
  index: null,
  status: 'active'
}

export default PlaylistForm
